<template>
	<BaseCard
		:is-editable="!isProcessFinished && isEditAllowed"
		:title="title"
		@clickEdit="$router.push({ name: editRoute, params: { id: $route.params.processId || $route.params.id } })"
		:is-toggle-open="isToggleOpen"
		:is-toggleable="true"
		@toggleCard="toggleCard($event)"
	>
		<div class="-mr-2" v-if="images.length">
			<CoolLightBox :items="getLightBoxImages" :index="index" @close="index = null"> </CoolLightBox>
			<div class="flex w-full flex-wrap justify-between">
				<div class="w-1/4 mr-2 pb-2 box-border flex-grow" v-for="(metaInfoImage, metaInfoImageIndex) in images" :key="metaInfoImageIndex">
					<img
						:src="metaInfoImage.base64Content"
						:alt="title"
						@click="index = metaInfoImageIndex"
						class="w-full bg-cover bg-center flex flex-grow cursor-pointer"
					/>
				</div>
			</div>
		</div>
		<div class="font-bold" v-else-if="emptyMessage">{{ emptyMessage }}</div>
		<div class="font-bold" v-else>{{ title }} {{ $t('not_stored_plural') }}</div>
	</BaseCard>
</template>
<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';

export default {
	name: 'ImagesCard',
	components: { BaseCard },
	props: {
		isProcessFinished: {},
		images: { required: true },
		title: { type: String, required: true },
		isEditAllowed: { type: Boolean, default: true },
		editRoute: { type: String },
		isToggleOpen: { type: Boolean, default: true },
		emptyMessage: { type: String, required: false },
	},
	data() {
		return {
			index: null,
		};
	},
	computed: {
		getLightBoxImages() {
			return this.images
				.map(metaInfo => {
					if (metaInfo.base64Content) {
						return metaInfo.base64Content;
					}
				})
				.filter(value => value);
		},
	},
	methods: {
		toggleCard($event) {
			this.$emit('toggleCard', $event);
		},
	},
};
</script>
